import React from 'react';
import Button from '../components/Button';

const Courses = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="hero" style={{ minHeight: '40vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Complete Course Catalog</h1>
                    <p className="hero-subtitle">From Beginner to Professional - Master All Traditional Weapons</p>
                </div>
            </section>

            {/* Silambam Beginner */}
            <section id="silambam" className="section section-dark">
                <div className="course-card">
                    <span className="course-level" style={{ background: 'var(--color-green)' }}>Regular Program</span>
                    <h2 className="course-title">Silambam – Regular Program</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', color: 'var(--color-gray-light)' }}>
                        Start your journey with the foundation of Silambam. This course introduces you to the bamboo staff and teaches
                        essential techniques that form the basis of all advanced training.
                    </p>
                    <h3 style={{ color: 'var(--color-gold-light)', margin: '1.5rem 0 1rem' }}>What You'll Learn:</h3>
                    <ul className="course-list">
                        <li>Learn complete Silambam basics (leg work, rotations, 9 fundamentals)</li>
                        <li>Progressive training: Nagam 16 (14 lessons) & Idiyappan Parambarai (6 lessons)</li>
                        <li>Alangaram skills including double stick, star stick, poo panthu & more</li>
                        <li>Weapons training introduced as students progress</li>
                        <li>Live online classes with personal corrections</li>
                        <li>Same training content for Monthly, Biannual, and Annual plans (only payment differs)</li>
                    </ul>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/registration">Enroll in Beginner Course</Button>
                    </div>
                </div>
            </section>

            {/* Other Events */}
            <section className="section section-gradient">
                <div className="course-card">
                    <span className="course-level" style={{ background: 'var(--color-gold)' }}>Other Events and programs</span>
                    <h2 className="course-title">Other Events and Programs</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', color: 'var(--color-gray-light)' }}>
                        Specialized training and performances. (CONTACT FOR PRICE)
                    </p>
                    <h3 style={{ color: 'var(--color-gold-light)', margin: '1.5rem 0 1rem' }}>Our Offerings:</h3>
                    <ul className="course-list">
                        <li>School / college events</li>
                        <li>Corporate events</li>
                        <li>Cinematic programs</li>
                    </ul>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/contact">Contact for Events</Button>
                    </div>
                </div>
            </section>

            {/* Short-Term Programs */}
            <section className="section section-dark">
                <div className="course-card">
                    <span className="course-level" style={{ background: 'var(--color-red)' }}>SHORT-TERM PROGRAMS</span>
                    <h2 className="course-title">Short-Term Programs</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', color: 'var(--color-gray-light)' }}>
                        Quick, focused courses.
                    </p>
                    <h3 style={{ color: 'var(--color-gold-light)', margin: '1.5rem 0 1rem' }}>Programs:</h3>
                    <ul className="course-list">
                        <li>Introduction - Free / Free</li>
                        <li>Beginner course - ₹499</li>
                        <li>15 days - ₹599 / $25 USD</li>
                        <li>30 days - ₹999 / $50 USD</li>
                    </ul>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/registration" state={{ programCategory: 'shortTerm' }}>Enroll in Short-Term Course</Button>
                    </div>
                </div>
            </section>

            {/* Specialized Skill Programs */}
            <section id="specialized-skills" className="section section-gradient">
                <div className="course-card">
                    <span className="course-level" style={{ background: 'var(--color-gold)' }}>SPECIALIZED SKILL PROGRAMS</span>
                    <h2 className="course-title">Specialized Skill Programs</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', color: 'var(--color-gray-light)' }}>
                        Mastery courses. (CONTACT FOR PRICE)
                    </p>
                    <h3 style={{ color: 'var(--color-gold-light)', margin: '1.5rem 0 1rem' }}>Courses:</h3>
                    <ul className="course-list">
                        <li>Nagam 16 Techniques Course (14 lessons)</li>
                        <li>Idiyappan Parambarai Course (6 lessons)</li>
                        <li>Alangaram Performance Course</li>
                        <li>Weapons Mastery Course</li>
                        <li>Silambam Fight & Combat Course</li>
                    </ul>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/contact">Contact for Specialized Program</Button>
                    </div>
                </div>
            </section>

            {/* Maan Kombu */}
            {/* <section id="maan-kombu" className="section section-dark">
                <div className="course-card">
                    <span className="course-level" style={{ background: 'var(--color-gold)' }}>Weapon Specialization</span>
                    <h2 className="course-title">Maan Kombu (Deer Horn Weapon)</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', color: 'var(--color-gray-light)' }}>
                        Train with the traditional deer horn weapons, a close-combat system that emphasizes locking, hooking, and
                        precise control.
                    </p>
                    <h3 style={{ color: 'var(--color-gold-light)', margin: '1.5rem 0 1rem' }}>What You'll Learn:</h3>
                    <ul className="course-list">
                        <li>Combat grip - proper hand positioning for effectiveness</li>
                        <li>Locking techniques - joint locks and control methods</li>
                        <li>Hooking attacks - offensive techniques using the curved horns</li>
                        <li>Traditional footwork - mobility patterns specific to this weapon</li>
                        <li>Defense applications - protecting against various attacks</li>
                    </ul>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/registration">Enroll in Maan Kombu Course</Button>
                    </div>
                </div>
            </section> */}

            {/* Double Stick */}
            {/* <section id="double-stick" className="section section-gradient">
                <div className="course-card">
                    <span className="course-level" style={{ background: 'var(--color-gold)' }}>Weapon Specialization</span>
                    <h2 className="course-title">Double Stick (Irattai Silambam)</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem', color: 'var(--color-gray-light)' }}>
                        Master the art of wielding two sticks simultaneously. This challenging discipline requires exceptional
                        coordination and builds incredible ambidexterity.
                    </p>
                    <h3 style={{ color: 'var(--color-gold-light)', margin: '1.5rem 0 1rem' }}>What You'll Learn:</h3>
                    <ul className="course-list">
                        <li>Dual-hand coordination - independent control of both weapons</li>
                        <li>Rapid strikes - high-speed attack sequences</li>
                        <li>Rhythm drills - maintaining tempo and flow</li>
                        <li>8-direction attack system - comprehensive offensive angles</li>
                        <li>Mirror techniques - synchronized movements</li>
                    </ul>
                    <div style={{ marginTop: '2rem' }}>
                        <Button to="/registration">Enroll in Double Stick Course</Button>
                    </div>
                </div>
            </section> */}



            {/* CTA */}
            <section className="section section-gradient" style={{ textAlign: 'center', padding: '5rem 2rem' }}>
                <h2 style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>Ready to Start Training?</h2>
                <p style={{ fontSize: '1.3rem', marginBottom: '2rem', color: 'var(--color-gold-light)' }}>
                    Choose your course and begin your transformation into a Silambam warrior.
                </p>
                <div className="btn-group">
                    <Button to="/registration" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>Register Now</Button>
                    <Button to="/pricing" variant="secondary" style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}>View Pricing</Button>
                </div>
            </section>
        </>
    );
};

export default Courses;
